<div class="ticket-detail">
    <!-- Loading -->
    <div *ngIf="loading" class="detail-status">
        <div class="sw-spinner"></div>
        <span>Loading...</span>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="detail-status detail-error">
        <p>{{ error }}</p>
        <button class="sw-btn sw-btn-outline" (click)="loadTicket()">Retry</button>
    </div>

    <!-- Ticket detail -->
    <ng-container *ngIf="ticket && !loading">
        <div class="detail-header">
            <h3 class="detail-summary">{{ getFieldValue('summary') || ticket.summary }}</h3>
            <div class="detail-meta">
                <span class="detail-status-badge">{{ ticket.currentStatus?.status || 'Unknown' }}</span>
                <span class="detail-date">{{ ticket.createdDate?.friendly || ticket.createdDate }}</span>
            </div>
        </div>

        <div class="detail-description">
            {{ getFieldValue('description') }}
        </div>

        <!-- Confirm completion (done tickets only) -->
        <div *ngIf="isDone" class="detail-confirm">
            <button *ngIf="!confirmingPrompt" class="sw-btn sw-btn-primary sw-confirm-btn" (click)="startConfirm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                </svg>
                Confirm completion
            </button>

            <ng-container *ngIf="confirmingPrompt">
                <p class="sw-confirm-msg">This will close the ticket and remove it from your list. Continue?</p>
                <div class="sw-confirm-actions">
                    <button class="sw-btn sw-btn-outline sw-btn-sm" (click)="cancelConfirm()"
                        [disabled]="confirming">Cancel</button>
                    <button class="sw-btn sw-btn-primary sw-btn-sm" (click)="confirm()" [disabled]="confirming">
                        {{ confirming ? 'Confirming...' : 'Confirm' }}
                    </button>
                </div>
            </ng-container>

            <p *ngIf="confirmError" class="sw-confirm-msg sw-confirm-error">{{ confirmError }}</p>
        </div>

        <!-- Comments -->
        <div class="detail-comments">
            <div class="detail-section-title">Activity</div>

            <div *ngIf="comments.length === 0" class="detail-no-comments">No comments yet.</div>

            <div *ngFor="let comment of comments" class="comment-item">
                <div class="comment-header">
                    <span class="comment-author">{{ comment.author?.displayName || 'Unknown' }}</span>
                    <span class="comment-date">{{ comment.created?.friendly || comment.created }}</span>
                </div>
                <div class="comment-body">{{ comment.body }}</div>
            </div>
        </div>

        <!-- Add comment -->
        <div class="detail-add-comment">
            <textarea class="sw-textarea" placeholder="Add a comment..." [(ngModel)]="newComment"
                [disabled]="submittingComment" rows="3"></textarea>
            <button class="sw-btn sw-btn-primary sw-btn-sm" (click)="addComment()"
                [disabled]="!newComment.trim() || submittingComment">
                {{ submittingComment ? 'Sending...' : 'Send' }}
            </button>
        </div>
    </ng-container>
</div>
